// Per-environment visibility for opt-in (requires_enablement) Paradex
// products, mirrored by hand from the backend's Flipt gate.
//
// SOURCE OF TRUTH: infra/helm/featureflags/flipt.yaml
// (FEATURE_UM_PRODUCT_ENABLEMENT). The backend already hides these from
// the instrument list and rejects them on trade per env; this mirror
// keeps the product SELECTOR in lockstep so a product enabled in one env
// never renders in another (e.g. ZEC options must not show on prod).
//
// MAINTENANCE: this duplicates the Flipt variants, so it MUST change in
// the same release as any FEATURE_UM_PRODUCT_ENABLEMENT edit. In
// particular XC (BTC perp) is enabled on staging/testnet by PR #34710,
// which ships with this; if that slips, XC drops back to production-only.
// A generator replaces this map next (the no-drift follow-up).
//
// Keys = opt-in codes (PRODUCTS_REQUIRING_ENABLEMENT). Values = the UI
// environments (test/stage/production) the code is offered in. A code
// absent here is not gated and always shows.
const PRODUCT_ENABLEMENT_ENVS: Record<string, readonly string[]> = {
  XC: ['stage', 'test', 'production'], // BTC perp (staging/testnet via #34710)
  XD: ['stage', 'test', 'production'],
  XF: ['stage', 'test', 'production'],
  XG: ['test', 'production'],
  XH: ['test', 'production'],
  XI: ['test', 'production'],
  XJ: ['test', 'production'],
  XK: ['production'],
  XL: ['production'],
  XM: ['stage', 'test', 'production'],
  XN: ['production'],
  XO: ['production'],
  XP: ['production'],
  XQ: ['test', 'production'],
  XS: ['test', 'production'],
  XT: ['test', 'production'],
  XU: ['production'],
  XV: ['production'],
  XW: ['production'],
  XX: ['production'],
  XY: ['production'],
  XZ: ['production'],
  ZA: ['production'],
  ZB: ['production'],
  ZC: ['production'],
  ZD: ['production'],
  ZE: ['production'],
  ZF: ['production'],
  ZG: ['production'],
  ZH: ['production'],
  ZI: ['production'],
  ZJ: ['stage', 'test'], // ZEC options: testnet/staging only (hidden on prod)
};

// Envs where the gate applies. Outside these (local dev, preview),
// everything shows so local development isn't crippled; the backend
// still hides/rejects there.
const GATED_ENVS = new Set(['stage', 'test', 'production']);

export const isProductEnabledInEnv = (code: string): boolean => {
  const envs = PRODUCT_ENABLEMENT_ENVS[code];
  if (envs == null || !GATED_ENVS.has(ENVIRONMENT)) return true;
  return envs.includes(ENVIRONMENT);
};
